import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/customer-support.png'


const _hoisted_1 = {
  id: "receive-item",
  class: "relative"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex icon mr-3" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "lg:min-w-full sm:max-w-sm mx-auto"
  })
], -1)
const _hoisted_3 = { class: "mt-4 md:mt-0 md:flex w-full" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sm:mt-4" }, [
  /*#__PURE__*/_createVNode("h5", { style: {"color":"#16191C"} }, "Ada yang bisa kami bantu?"),
  /*#__PURE__*/_createVNode("span", { class: "font-semibold text-sm mb-2 mt-4 color-blue-grey" }, "Laporkan kendala yang anda alami dengan mengisi form di bawah ini")
], -1)
const _hoisted_5 = { class: "flex items-end text-sm md:flex-row-reverse mt-4 md:mt-0 md:ml-auto" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Cek laporan aktif ")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-right cursor-pointer " }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-unlock mr-2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Login Tiket ")
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col max-w-4xl mx-auto"
}
const _hoisted_12 = { class: "p-card p-component " }
const _hoisted_13 = { class: "p-card-body" }
const _hoisted_14 = { class: "p-field mb-4 w-full" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "p-field mb-4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { for: "ticket-title" }, "Judul", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_19 = { class: "p-field mb-4 w-full" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { for: "deskripsi" }, "Keterangan", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_22 = { class: "flex justify-between action-button p-4" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Kirim Laporan")
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "p-ink" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" logout")
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "p-ink" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Lihat ticket")
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "p-ink" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "" }, {
      title: _withCtx(() => [
        _createVNode("div", {
          class: "sm:flex bg-gradient-to-l p-4 rounded-xl",
          style: { backgroundImage:'linear-gradient(90deg, rgba(255, 152, 0, 0.06) 0%, rgb(255 182 74 / 32%) 67.71%)' }
        }, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("a", {
                href: "#",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTicketPage && _ctx.openTicketPage(...args))),
                class: "color-primary ",
                style: {"{background":"`#E65100`}"}
              }, [
                _hoisted_6,
                _hoisted_7
              ])
            ])
          ])
        ], 4)
      ]),
      content: _withCtx(() => [
        (!_ctx.store.getters.getOpenTicketIsAuthen)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              true
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "p-button p-component btn-warning text-black mr-3 px-10 py-1",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.authUser && _ctx.authUser(...args)))
                  }, [
                    _hoisted_9,
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_InputText, {
                          id: "ticket-title",
                          class: "input-primary mt-1 w-full",
                          name: "title",
                          modelValue: _ctx.titleValue,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.titleValue = $event)),
                          type: "text",
                          placeholder: "Judul Kendala ..."
                        }, null, 8, ["modelValue"]),
                        _hoisted_18
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_Textarea, {
                      id: "deskripsi",
                      modelValue: _ctx.descriptionValue,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.descriptionValue = $event)),
                      class: "mt-1 input-primary w-full",
                      rows: "5"
                    }, null, 8, ["modelValue"]),
                    _hoisted_21
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("button", {
                  class: "p-button p-component btn-primary text-black mr-3 px-10 py-1",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submmitTciket && _ctx.submmitTciket(...args))),
                  disabled: _ctx.validate.isDisabled && false
                }, [
                  _hoisted_23,
                  _hoisted_24
                ], 8, ["disabled"]),
                false
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "p-button p-component btn-primary text-black mr-3 px-10 py-1",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.store.dispatch('setAppOpenticketAuthDefault', { expiredAt: _ctx.moment().subtract(10, 'minutes') }))),
                      disabled: _ctx.validate.isDisabled && false
                    }, [
                      _hoisted_25,
                      _hoisted_26
                    ], 8, ["disabled"]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: "justify-self-end p-button p-component btn-secondary text-black px-10 py-1",
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openTicketPage && _ctx.openTicketPage(...args)))
                    }, [
                      _hoisted_27,
                      _hoisted_28
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}